import React from "react";

const Loader = () => (
  <div className="loading-mask-inner">
    <div className="loading-mask-animation spinner">
      <div className="rect1" />
      <div className="rect2" />
      <div className="rect3" />
      <div className="rect4" />
      <div className="rect5" />
    </div>
  </div>
);

export default Loader;
